import { ArrowUpRight } from "lucide-react";
import { Logo, Watermark } from "../brand/Logo";
import { COTAS_URL } from "../../lib/site";

const HeroBtn = ({ children, testId, solid }) => (
  <a href={COTAS_URL} target="_blank" rel="noopener noreferrer" data-testid={testId}
    className={`group inline-flex items-center justify-center gap-2 rounded-full px-7 py-4 text-base font-semibold transition-[background-color,transform] duration-200 hover:-translate-y-0.5 ${
      solid ? "bg-[#F7F5F0] text-[#196ABC] hover:bg-white" : "border-2 border-[#F7F5F0]/60 text-[#F7F5F0] hover:bg-white/10"
    }`}>
    {children}
    <ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2.5} />
  </a>
);

export const Hero = () => (
  <section id="inicio" className="relative overflow-hidden bg-[#196ABC] pb-24 pt-36 sm:pb-32 sm:pt-44" data-testid="hero-section">
    <Watermark className="-right-40 -bottom-40 sm:-right-24 sm:-bottom-32" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Logo variant="vertical" tone="white" className="cc-rise mb-12" />
      <h1 className="cc-rise cc-d1 max-w-4xl text-4xl font-extrabold uppercase leading-[1.05] tracking-tight text-[#F7F5F0] sm:text-5xl lg:text-6xl"
        data-testid="hero-title">
        Sonhos importantes não precisam ficar na fila.
      </h1>
      <p className="cc-rise cc-d2 mt-8 max-w-2xl text-base leading-relaxed text-[#F7F5F0]/85 sm:text-lg" data-testid="hero-subtitle">
        O Clube do Contemplado transforma espera em movimento. Conecta pessoas a créditos já contemplados com curadoria,
        clareza e acompanhamento, para que decisões importantes avancem sem depender da espera tradicional do consórcio.
      </p>
      <div className="cc-rise cc-d3 mt-10 flex flex-col items-start gap-4 sm:flex-row">
        <HeroBtn testId="hero-btn-imoveis" solid>Ver cartas de imóveis</HeroBtn>
        <HeroBtn testId="hero-btn-veiculos">Ver cartas de veículos</HeroBtn>
      </div>
      <p className="cc-rise cc-d4 mt-14 font-serif text-2xl italic text-[#F7F5F0]/75">Clareza para decidir, agilidade para avançar.</p>
    </div>
  </section>
);
